<template>
  <div style="display: flex;" v-if="rowData">
    <button
      type="button"
      title="Delete Agreement"
      class="btn btn-primary ml-2 userButtons"
      v-on:click="callParentDeleteFunction()"
    >
      <i class="icon-bin2"></i>
    </button>
    <el-switch
      active-color="#13ce66"
      inactive-color="#ad466c"
      v-model="rowData.enabled"
      style="margin:0 auto; display:block"
      class="mt-1"
      @change="callParentDisableFunction"
    ></el-switch>
    <!-- <input type="checkbox" /> -->
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'averagingAgreementTableButtons',
  data() {
    return {
      rowData: null
    };
  },
  methods: {
    callParentDeleteFunction: function() {
      this.params.context.componentParent.deleteAgreement(
        this.params.data.docID,
        this.params.rowIndex
      );
    },
    callParentDisableFunction: function() {
      this.params.context.componentParent.disableAgreement(
        this.params.data.docID,
        this.rowData.enabled,
        this.params.rowIndex
      );
    }
  },
  mounted() {
    this.rowData = JSON.parse(JSON.stringify(this.params.data));
  }
});
</script>
